import React from 'react';
import { FormControl, FormControlLabel, Checkbox, FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SurveyComponent } from '../../../../models/SurveyTemplates';
import { Namespace } from '../../../../locales/translations';

interface CheckboxesFieldProps {
    field: SurveyComponent;
    value?: string[];
    onChange?: (value: string[]) => void;
    disabled?: boolean;
}

const CheckboxesField: React.FC<CheckboxesFieldProps> = ({
    field,
    value = [],
    onChange,
    disabled = false
}) => {
    const { t } = useTranslation([Namespace.FORMS]);//TODO: change to Namespace.SURVEY_BUILDER

    const handleChange = (optionValue: string, checked: boolean) => {
        if (!onChange) return;
        
        if (checked) {
            onChange([...value, optionValue]);
        } else {
            onChange(value.filter(v => v !== optionValue));
        }
    };

    if (!field.options || field.options.length === 0) {
        return (
            <FormControl component="fieldset" fullWidth disabled={disabled}>
                <FormGroup>
                    <FormControlLabel
                        control={<Checkbox />}
                        label={t('field_messages.checkboxes.add_options')}
                        disabled
                    />
                </FormGroup>
            </FormControl>
        );
    }

    return (
        <FormControl component="fieldset" fullWidth disabled={disabled}>
            <FormGroup>
                {field.options.map((option) => (
                    <FormControlLabel
                        key={option.id}
                        control={
                            <Checkbox
                                checked={value.includes(option.value)}
                                onChange={(e) => handleChange(option.value, e.target.checked)}
                            />
                        }
                        label={option.label}
                    />
                ))}
            </FormGroup>
        </FormControl>
    );
};

export default CheckboxesField;
